/**
 * GENERATED CODE – DO NOT EDIT!
 */
/* eslint-disable */
import * as $protobuf from 'protobufjs/light';
import { fixType } from '../../../Fixes';
import Builder from '../../../Builder';
import '../instant_access_program_model';
const $root = $protobuf.roots['default'] || ($protobuf.roots['default'] = new $protobuf.Root());
const jsonData = {
  "squareup": {
    "nested": {
      "inflows": {
        "nested": {
          "service": {
            "nested": {
              "InstantAccessError": {
                "values": {
                  "INSTANT_ACCESS_ERROR_DO_NOT_USE": 0,
                  "GENERIC_INSTANT_ACCESS_ERROR": 1
                }
              },
              "GlyphIcon": {
                "values": {
                  "DO_NOT_USE_GLYPH_ICON": 0,
                  "DOORDASH": 5,
                  "UBER_EATS": 6,
                  "GRUBHUB": 7
                }
              },
              "PillDescription": {
                "fields": {
                  "text": {
                    "type": "string",
                    "id": 1,
                    "rule": "optional"
                  },
                  "icon": {
                    "type": ".squareup.inflows.service.GlyphIcon",
                    "id": 2,
                    "rule": "optional"
                  },
                  "variant": {
                    "type": ".squareup.inflows.service.PillDescription.PillVariant",
                    "id": 3,
                    "rule": "optional",
                    "options": {
                      "default": "PILL_VARIANT_DEFERRED"
                    }
                  },
                  "size": {
                    "type": ".squareup.inflows.service.PillDescription.PillSize",
                    "id": 4,
                    "rule": "optional",
                    "options": {
                      "default": "PILL_SIZE_DEFERRED"
                    }
                  }
                },
                "nested": {
                  "PillVariant": {
                    "values": {
                      "PILL_VARIANT_DEFERRED": 0,
                      "PILL_VARIANT_NORMAL": 1,
                      "PILL_VARIANT_EMPHASIS": 2,
                      "PILL_VARIANT_SUCCESS": 3,
                      "PILL_VARIANT_WARNING": 4
                    }
                  },
                  "PillSize": {
                    "values": {
                      "PILL_SIZE_DEFERRED": 0,
                      "PILL_SIZE_NORMAL": 1
                    }
                  }
                }
              },
              "InstantAccessRequirementItem": {
                "fields": {
                  "type": {
                    "type": ".squareup.inflows.service.InstantAccessRequirementItem.Type",
                    "id": 1,
                    "rule": "optional"
                  },
                  "isDisabled": {
                    "type": "bool",
                    "id": 8,
                    "rule": "optional"
                  }
                },
                "nested": {
                  "Type": {
                    "values": {
                      "INSTANT_ACCESS_REQUIREMENT_ITEM_TYPE_DO_NOT_USE": 0,
                      "ACTIVE_CHECKING_ACCOUNT": 1,
                      "DIRECT_DEPOSITS_SETUP": 2,
                      "ORDERS_INTEGRATION_SETUP": 3
                    }
                  }
                }
              },
              "InstantAccessAccordionItem": {
                "fields": {
                  "platformLabel": {
                    "type": "string",
                    "id": 1,
                    "rule": "optional"
                  },
                  "logoImageUrl": {
                    "type": "string",
                    "id": 2,
                    "rule": "optional"
                  },
                  "logoImageBackgroundColorCode": {
                    "type": "string",
                    "id": 3,
                    "rule": "optional"
                  },
                  "pillDescription": {
                    "type": ".squareup.inflows.service.PillDescription",
                    "id": 4,
                    "rule": "optional"
                  },
                  "requirementItems": {
                    "type": ".squareup.inflows.service.InstantAccessRequirementItem",
                    "id": 5,
                    "rule": "repeated"
                  },
                  "isDisabled": {
                    "type": "bool",
                    "id": 6,
                    "rule": "optional"
                  }
                }
              },
              "OnboardToInstantAccessRequest": {
                "fields": {
                  "optInMechanism": {
                    "type": ".squareup.inflows.InstantAccessProgram.OptInMechanism",
                    "id": 1,
                    "rule": "optional"
                  },
                  "unitToken": {
                    "type": "string",
                    "id": 2,
                    "rule": "optional"
                  },
                  "unitTokens": {
                    "type": "string",
                    "id": 3,
                    "rule": "repeated"
                  }
                }
              },
              "OnboardToInstantAccessResponse": {
                "fields": {
                  "success": {
                    "type": ".squareup.inflows.service.OnboardToInstantAccessResponse.Success",
                    "id": 1
                  },
                  "failure": {
                    "type": ".squareup.inflows.service.OnboardToInstantAccessResponse.Failure",
                    "id": 2
                  }
                },
                "nested": {
                  "Success": {
                    "fields": {}
                  },
                  "Failure": {
                    "fields": {
                      "errors": {
                        "type": ".squareup.inflows.service.InstantAccessError",
                        "id": 1,
                        "rule": "repeated"
                      }
                    }
                  },
                  "result": {
                    "oneof": ["success", "failure"]
                  }
                }
              },
              "RequestPinwheelLinkTokenRequest": {
                "fields": {
                  "unitToken": {
                    "type": "string",
                    "id": 1,
                    "rule": "optional"
                  },
                  "platform": {
                    "type": ".squareup.inflows.InstantAccessProgram.Platform",
                    "id": 2,
                    "rule": "optional"
                  }
                }
              },
              "RequestPinwheelLinkTokenResponse": {
                "fields": {
                  "success": {
                    "type": ".squareup.inflows.service.RequestPinwheelLinkTokenResponse.Success",
                    "id": 1
                  },
                  "failure": {
                    "type": ".squareup.inflows.service.RequestPinwheelLinkTokenResponse.Failure",
                    "id": 2
                  }
                },
                "nested": {
                  "Success": {
                    "fields": {
                      "linkToken": {
                        "type": "string",
                        "id": 1,
                        "rule": "optional"
                      }
                    }
                  },
                  "Failure": {
                    "fields": {
                      "errors": {
                        "type": ".squareup.inflows.service.InstantAccessError",
                        "id": 1,
                        "rule": "repeated"
                      }
                    }
                  },
                  "result": {
                    "oneof": ["success", "failure"]
                  }
                }
              },
              "RetrieveInstantAccessRequirementsStateRequest": {
                "fields": {
                  "unitToken": {
                    "type": "string",
                    "id": 1,
                    "rule": "optional"
                  }
                }
              },
              "RetrieveInstantAccessRequirementsStateResponse": {
                "fields": {
                  "success": {
                    "type": ".squareup.inflows.service.RetrieveInstantAccessRequirementsStateResponse.Success",
                    "id": 1
                  },
                  "failure": {
                    "type": ".squareup.inflows.service.RetrieveInstantAccessRequirementsStateResponse.Failure",
                    "id": 2
                  }
                },
                "nested": {
                  "Success": {
                    "fields": {
                      "accordionItems": {
                        "type": ".squareup.inflows.service.InstantAccessAccordionItem",
                        "id": 1,
                        "rule": "repeated"
                      },
                      "optedIn": {
                        "type": "bool",
                        "id": 2,
                        "rule": "optional"
                      }
                    }
                  },
                  "Failure": {
                    "fields": {
                      "errors": {
                        "type": ".squareup.inflows.service.InstantAccessError",
                        "id": 1,
                        "rule": "repeated"
                      }
                    }
                  },
                  "result": {
                    "oneof": ["success", "failure"]
                  }
                }
              },
              "ListDDSEligibleUnitsRequest": {
                "fields": {
                  "merchantToken": {
                    "type": "string",
                    "id": 1,
                    "rule": "optional"
                  }
                }
              },
              "DDSEligibleUnitInfo": {
                "fields": {
                  "unitToken": {
                    "type": "string",
                    "id": 1,
                    "rule": "optional"
                  },
                  "integrationToOptInStatus": {
                    "type": ".squareup.inflows.service.DDSEligibleUnitInfo.IntegrationToOptInStatus",
                    "id": 2,
                    "rule": "repeated"
                  }
                },
                "nested": {
                  "IntegrationToOptInStatus": {
                    "fields": {
                      "platform": {
                        "type": ".squareup.inflows.InstantAccessProgram.Platform",
                        "id": 1,
                        "rule": "optional"
                      },
                      "isOptedIn": {
                        "type": "bool",
                        "id": 2,
                        "rule": "optional"
                      }
                    }
                  }
                }
              },
              "ListDDSEligibleUnitsResponse": {
                "fields": {
                  "success": {
                    "type": ".squareup.inflows.service.ListDDSEligibleUnitsResponse.Success",
                    "id": 1
                  },
                  "failure": {
                    "type": ".squareup.inflows.service.ListDDSEligibleUnitsResponse.Failure",
                    "id": 2
                  }
                },
                "nested": {
                  "Success": {
                    "fields": {
                      "units": {
                        "type": ".squareup.inflows.service.DDSEligibleUnitInfo",
                        "id": 1,
                        "rule": "repeated"
                      }
                    }
                  },
                  "Failure": {
                    "fields": {
                      "errors": {
                        "type": ".squareup.inflows.service.InstantAccessError",
                        "id": 1,
                        "rule": "repeated"
                      }
                    }
                  },
                  "result": {
                    "oneof": ["success", "failure"]
                  }
                }
              },
              "ExternalInstantAccessService": {
                "methods": {
                  "OnboardToInstantAccess": {
                    "requestType": ".squareup.inflows.service.OnboardToInstantAccessRequest",
                    "responseType": ".squareup.inflows.service.OnboardToInstantAccessResponse"
                  },
                  "RequestPinwheelLinkToken": {
                    "requestType": ".squareup.inflows.service.RequestPinwheelLinkTokenRequest",
                    "responseType": ".squareup.inflows.service.RequestPinwheelLinkTokenResponse"
                  },
                  "RetrieveInstantAccessRequirementsState": {
                    "requestType": ".squareup.inflows.service.RetrieveInstantAccessRequirementsStateRequest",
                    "responseType": ".squareup.inflows.service.RetrieveInstantAccessRequirementsStateResponse"
                  },
                  "ListDDSEligibleUnits": {
                    "requestType": ".squareup.inflows.service.ListDDSEligibleUnitsRequest",
                    "responseType": ".squareup.inflows.service.ListDDSEligibleUnitsResponse"
                  }
                }
              }
            }
          }
        }
      }
    }
  }
};

// Do not initialize these protos if they have already been defined
if (!$root.nested?.squareup?.nested?.inflows?.nested?.service?.nested?.InstantAccessError && !$root.nested?.squareup?.nested?.inflows?.nested?.service?.nested?.GlyphIcon && !$root.nested?.squareup?.nested?.inflows?.nested?.service?.nested?.PillDescription && !$root.nested?.squareup?.nested?.inflows?.nested?.service?.nested?.PillDescription?.nested?.PillVariant && !$root.nested?.squareup?.nested?.inflows?.nested?.service?.nested?.PillDescription?.nested?.PillSize && !$root.nested?.squareup?.nested?.inflows?.nested?.service?.nested?.InstantAccessRequirementItem && !$root.nested?.squareup?.nested?.inflows?.nested?.service?.nested?.InstantAccessRequirementItem?.nested?.Type && !$root.nested?.squareup?.nested?.inflows?.nested?.service?.nested?.InstantAccessAccordionItem && !$root.nested?.squareup?.nested?.inflows?.nested?.service?.nested?.OnboardToInstantAccessRequest && !$root.nested?.squareup?.nested?.inflows?.nested?.service?.nested?.OnboardToInstantAccessResponse && !$root.nested?.squareup?.nested?.inflows?.nested?.service?.nested?.OnboardToInstantAccessResponse?.nested?.Success && !$root.nested?.squareup?.nested?.inflows?.nested?.service?.nested?.OnboardToInstantAccessResponse?.nested?.Failure && !$root.nested?.squareup?.nested?.inflows?.nested?.service?.nested?.RequestPinwheelLinkTokenRequest && !$root.nested?.squareup?.nested?.inflows?.nested?.service?.nested?.RequestPinwheelLinkTokenResponse && !$root.nested?.squareup?.nested?.inflows?.nested?.service?.nested?.RequestPinwheelLinkTokenResponse?.nested?.Success && !$root.nested?.squareup?.nested?.inflows?.nested?.service?.nested?.RequestPinwheelLinkTokenResponse?.nested?.Failure && !$root.nested?.squareup?.nested?.inflows?.nested?.service?.nested?.RetrieveInstantAccessRequirementsStateRequest && !$root.nested?.squareup?.nested?.inflows?.nested?.service?.nested?.RetrieveInstantAccessRequirementsStateResponse && !$root.nested?.squareup?.nested?.inflows?.nested?.service?.nested?.RetrieveInstantAccessRequirementsStateResponse?.nested?.Success && !$root.nested?.squareup?.nested?.inflows?.nested?.service?.nested?.RetrieveInstantAccessRequirementsStateResponse?.nested?.Failure && !$root.nested?.squareup?.nested?.inflows?.nested?.service?.nested?.ListDDSEligibleUnitsRequest && !$root.nested?.squareup?.nested?.inflows?.nested?.service?.nested?.DDSEligibleUnitInfo && !$root.nested?.squareup?.nested?.inflows?.nested?.service?.nested?.DDSEligibleUnitInfo?.nested?.IntegrationToOptInStatus && !$root.nested?.squareup?.nested?.inflows?.nested?.service?.nested?.ListDDSEligibleUnitsResponse && !$root.nested?.squareup?.nested?.inflows?.nested?.service?.nested?.ListDDSEligibleUnitsResponse?.nested?.Success && !$root.nested?.squareup?.nested?.inflows?.nested?.service?.nested?.ListDDSEligibleUnitsResponse?.nested?.Failure && !$root.nested?.squareup?.nested?.inflows?.nested?.service?.nested?.ExternalInstantAccessService) {
  $root.addJSON(jsonData);
}

/**
 * SOURCE InstantAccessError @ squareup/inflows/service/external_instant_access_service.proto at 13:1
 */
export const InstantAccessError = $root.lookupEnum('squareup.inflows.service.InstantAccessError').values;
/**
 * SOURCE GlyphIcon @ squareup/inflows/service/external_instant_access_service.proto at 18:1
 */
export const GlyphIcon = $root.lookupEnum('squareup.inflows.service.GlyphIcon').values;
/**
 * Configuration for a pill element.
 * @see <a href="https://www.figma.com/file/BKizTk0NavqV0IZS58rPXk/Market-1.0?node-id=127056-293706&t=WyErUcd04HTzDkYR-4">Market - Pill</a>
 *
 * SOURCE PillDescription @ squareup/inflows/service/external_instant_access_service.proto at 37:1
 */
export const PillDescription = $root.lookupType('squareup.inflows.service.PillDescription');
fixType(PillDescription, {
  text: {
    notEmpty: true
  }
});
Builder.createAndAttachToType(PillDescription);
/**
 * SOURCE PillVariant @ squareup/inflows/service/external_instant_access_service.proto at 43:3
 */
PillDescription.PillVariant = $root.lookupEnum('squareup.inflows.service.PillDescription.PillVariant').values;
/**
 * SOURCE PillSize @ squareup/inflows/service/external_instant_access_service.proto at 51:3
 */
PillDescription.PillSize = $root.lookupEnum('squareup.inflows.service.PillDescription.PillSize').values;
/**
 * SOURCE InstantAccessRequirementItem @ squareup/inflows/service/external_instant_access_service.proto at 57:1
 */
export const InstantAccessRequirementItem = $root.lookupType('squareup.inflows.service.InstantAccessRequirementItem');
fixType(InstantAccessRequirementItem, {
  type: {
    required: true
  }
});
Builder.createAndAttachToType(InstantAccessRequirementItem);
/**
 * SOURCE Type @ squareup/inflows/service/external_instant_access_service.proto at 58:3
 */
InstantAccessRequirementItem.Type = $root.lookupEnum('squareup.inflows.service.InstantAccessRequirementItem.Type').values;
/**
 * SOURCE InstantAccessAccordionItem @ squareup/inflows/service/external_instant_access_service.proto at 83:1
 */
export const InstantAccessAccordionItem = $root.lookupType('squareup.inflows.service.InstantAccessAccordionItem');
fixType(InstantAccessAccordionItem);
Builder.createAndAttachToType(InstantAccessAccordionItem);
/**
 * SOURCE OnboardToInstantAccessRequest @ squareup/inflows/service/external_instant_access_service.proto at 92:1
 */
export const OnboardToInstantAccessRequest = $root.lookupType('squareup.inflows.service.OnboardToInstantAccessRequest');
fixType(OnboardToInstantAccessRequest, {
  optInMechanism: {
    required: true
  }
});
Builder.createAndAttachToType(OnboardToInstantAccessRequest);
/**
 * SOURCE OnboardToInstantAccessResponse @ squareup/inflows/service/external_instant_access_service.proto at 98:1
 */
export const OnboardToInstantAccessResponse = $root.lookupType('squareup.inflows.service.OnboardToInstantAccessResponse');
fixType(OnboardToInstantAccessResponse);
Builder.createAndAttachToType(OnboardToInstantAccessResponse);
/**
 * SOURCE Success @ squareup/inflows/service/external_instant_access_service.proto at 104:3
 */
OnboardToInstantAccessResponse.Success = $root.lookupType('squareup.inflows.service.OnboardToInstantAccessResponse.Success');
fixType(OnboardToInstantAccessResponse.Success);
Builder.createAndAttachToType(OnboardToInstantAccessResponse.Success);
/**
 * SOURCE Failure @ squareup/inflows/service/external_instant_access_service.proto at 106:3
 */
OnboardToInstantAccessResponse.Failure = $root.lookupType('squareup.inflows.service.OnboardToInstantAccessResponse.Failure');
fixType(OnboardToInstantAccessResponse.Failure);
Builder.createAndAttachToType(OnboardToInstantAccessResponse.Failure);
/**
 * SOURCE RequestPinwheelLinkTokenRequest @ squareup/inflows/service/external_instant_access_service.proto at 111:1
 */
export const RequestPinwheelLinkTokenRequest = $root.lookupType('squareup.inflows.service.RequestPinwheelLinkTokenRequest');
fixType(RequestPinwheelLinkTokenRequest, {
  unitToken: {
    required: true
  },
  platform: {
    required: true
  }
});
Builder.createAndAttachToType(RequestPinwheelLinkTokenRequest);
/**
 * SOURCE RequestPinwheelLinkTokenResponse @ squareup/inflows/service/external_instant_access_service.proto at 116:1
 */
export const RequestPinwheelLinkTokenResponse = $root.lookupType('squareup.inflows.service.RequestPinwheelLinkTokenResponse');
fixType(RequestPinwheelLinkTokenResponse);
Builder.createAndAttachToType(RequestPinwheelLinkTokenResponse);
/**
 * SOURCE Success @ squareup/inflows/service/external_instant_access_service.proto at 122:3
 */
RequestPinwheelLinkTokenResponse.Success = $root.lookupType('squareup.inflows.service.RequestPinwheelLinkTokenResponse.Success');
fixType(RequestPinwheelLinkTokenResponse.Success);
Builder.createAndAttachToType(RequestPinwheelLinkTokenResponse.Success);
/**
 * SOURCE Failure @ squareup/inflows/service/external_instant_access_service.proto at 126:3
 */
RequestPinwheelLinkTokenResponse.Failure = $root.lookupType('squareup.inflows.service.RequestPinwheelLinkTokenResponse.Failure');
fixType(RequestPinwheelLinkTokenResponse.Failure);
Builder.createAndAttachToType(RequestPinwheelLinkTokenResponse.Failure);
/**
 * SOURCE RetrieveInstantAccessRequirementsStateRequest @ squareup/inflows/service/external_instant_access_service.proto at 131:1
 */
export const RetrieveInstantAccessRequirementsStateRequest = $root.lookupType('squareup.inflows.service.RetrieveInstantAccessRequirementsStateRequest');
fixType(RetrieveInstantAccessRequirementsStateRequest, {
  unitToken: {
    required: true
  }
});
Builder.createAndAttachToType(RetrieveInstantAccessRequirementsStateRequest);
/**
 * SOURCE RetrieveInstantAccessRequirementsStateResponse @ squareup/inflows/service/external_instant_access_service.proto at 135:1
 */
export const RetrieveInstantAccessRequirementsStateResponse = $root.lookupType('squareup.inflows.service.RetrieveInstantAccessRequirementsStateResponse');
fixType(RetrieveInstantAccessRequirementsStateResponse);
Builder.createAndAttachToType(RetrieveInstantAccessRequirementsStateResponse);
/**
 * SOURCE Success @ squareup/inflows/service/external_instant_access_service.proto at 141:3
 */
RetrieveInstantAccessRequirementsStateResponse.Success = $root.lookupType('squareup.inflows.service.RetrieveInstantAccessRequirementsStateResponse.Success');
fixType(RetrieveInstantAccessRequirementsStateResponse.Success);
Builder.createAndAttachToType(RetrieveInstantAccessRequirementsStateResponse.Success);
/**
 * SOURCE Failure @ squareup/inflows/service/external_instant_access_service.proto at 146:3
 */
RetrieveInstantAccessRequirementsStateResponse.Failure = $root.lookupType('squareup.inflows.service.RetrieveInstantAccessRequirementsStateResponse.Failure');
fixType(RetrieveInstantAccessRequirementsStateResponse.Failure);
Builder.createAndAttachToType(RetrieveInstantAccessRequirementsStateResponse.Failure);
/**
 * SOURCE ListDDSEligibleUnitsRequest @ squareup/inflows/service/external_instant_access_service.proto at 151:1
 */
export const ListDDSEligibleUnitsRequest = $root.lookupType('squareup.inflows.service.ListDDSEligibleUnitsRequest');
fixType(ListDDSEligibleUnitsRequest, {
  merchantToken: {
    notEmpty: true
  }
});
Builder.createAndAttachToType(ListDDSEligibleUnitsRequest);
/**
 * SOURCE DDSEligibleUnitInfo @ squareup/inflows/service/external_instant_access_service.proto at 155:1
 */
export const DDSEligibleUnitInfo = $root.lookupType('squareup.inflows.service.DDSEligibleUnitInfo');
fixType(DDSEligibleUnitInfo);
Builder.createAndAttachToType(DDSEligibleUnitInfo);
/**
 * SOURCE IntegrationToOptInStatus @ squareup/inflows/service/external_instant_access_service.proto at 158:3
 */
DDSEligibleUnitInfo.IntegrationToOptInStatus = $root.lookupType('squareup.inflows.service.DDSEligibleUnitInfo.IntegrationToOptInStatus');
fixType(DDSEligibleUnitInfo.IntegrationToOptInStatus);
Builder.createAndAttachToType(DDSEligibleUnitInfo.IntegrationToOptInStatus);
/**
 * SOURCE ListDDSEligibleUnitsResponse @ squareup/inflows/service/external_instant_access_service.proto at 168:1
 */
export const ListDDSEligibleUnitsResponse = $root.lookupType('squareup.inflows.service.ListDDSEligibleUnitsResponse');
fixType(ListDDSEligibleUnitsResponse);
Builder.createAndAttachToType(ListDDSEligibleUnitsResponse);
/**
 * SOURCE Success @ squareup/inflows/service/external_instant_access_service.proto at 174:3
 */
ListDDSEligibleUnitsResponse.Success = $root.lookupType('squareup.inflows.service.ListDDSEligibleUnitsResponse.Success');
fixType(ListDDSEligibleUnitsResponse.Success);
Builder.createAndAttachToType(ListDDSEligibleUnitsResponse.Success);
/**
 * SOURCE Failure @ squareup/inflows/service/external_instant_access_service.proto at 178:3
 */
ListDDSEligibleUnitsResponse.Failure = $root.lookupType('squareup.inflows.service.ListDDSEligibleUnitsResponse.Failure');
fixType(ListDDSEligibleUnitsResponse.Failure);
Builder.createAndAttachToType(ListDDSEligibleUnitsResponse.Failure);
/**
 * SOURCE ExternalInstantAccessService @ squareup/inflows/service/external_instant_access_service.proto at 183:1
 */
export const ExternalInstantAccessService = $root.lookupService('squareup.inflows.service.ExternalInstantAccessService');